import React from "react";

export default function FaqImage({ src }) {
  return (
    <div className='left-side-image'>
      <img src={src} alt='faq' />
    </div>
  );
}
